import * as yup from 'yup'
import { VALIDATION } from '../../constants.js'

import {
  requiredPrice,
  requiredString
} from '../../yup/schemas.js'

const { MESSAGES } = VALIDATION

export const adminCommonSchema = yup.object({
  id: requiredString.uuid(),
  jobPrice: requiredPrice.min(5, MESSAGES.MUST_BE_GREATER_OR_EQUAL_FIVE,).max(999999.99, 'Must be less than or equal to $999999.99')
}).objectRequired()

const patchJobPriceSchema = adminCommonSchema.pick(['jobPrice'])

const patchJobPriceSchemas = { back: patchJobPriceSchema, fromt: patchJobPriceSchema }

export default {
  patchJobPrice: patchJobPriceSchemas
}
